import React from 'react';
import Navbar from '../components/Navbar/Navbar';
import Footer from '../sections/Footer/Footer';
import Symptoms from '../sections/Symptoms/Symptoms';
import Services from '../sections/Services/Services';
import Bruxism from '../sections/Bruxism/Bruxism';
import ConsultationCTA from '../sections/ConsultationCTA/ConsultationCTA';

const ServicesPage = () => {
    return (
        <>
            <Navbar />
            <ConsultationCTA />
            <Services />
            <Bruxism />
            <Symptoms />
            <Footer />
        </>
    );
};

export default ServicesPage;